/**
 * @file:
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/9/5      1.0     First version
 *
 * 注意：
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React, {Fragment,PureComponent} from "react";
import Lang from "@/components/Lang/Lang";
import { Link } from "react-router-dom";
import {Spin,} from 'antd';
import PaymentCollectionDrawer from "../paymentCollectionDrawer/PaymentCollectionDrawer";
import TakeDeliveryGoodsDrawer from "../takeDeliveryGoodsDrawer/TakeDeliveryGoodsDrawer";
import SurveyTaskList from "../surveyTaskDrawer/SurveyTaskList";
import DopIndexAction from "../../dopIndex.action";
export default class ToDo extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        }
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    //子项
    renderItem(title,num=0,onlyChild=false){
        return (onlyChild?<Fragment>
            <div className={"black66 lineH_21"}>{title}</div>
            <div className={"font_16 fw_700 lineH_24 black89"}>{num}</div>
        </Fragment>:<div className={"commonBox item"}>
            <div className={"black66 lineH_21"}>{title}</div>
            <div className={"font_16 fw_700 lineH_24 black89"}>{num}</div>
        </div>)
    }
    /**
     * 首页代办统计
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8307
     */
    getTodo() {
        this.loading(true);
        DopIndexAction.postHttpAction("/service/mg/home/todo",{
        }).then(res=>this.getTodoRes(res.data)).catch(err=>this.getTodoRes(err));
    }
    getTodoRes(res){
        this.loading(false);
        const {success,valid,model={},} = res;
        if (success && valid) {
            this.setState({
                todoModel:model
            })
        }
    }
    componentWillMount() {
        this.getTodo()
    }

    componentDidMount() {
        if (this.props.onRef) this.props.onRef(this);
    }

    render() {
        const {loading = true,todoModel={}} = this.state;
        return (<Spin spinning={loading}>
            <div className={"font_18 fw_500 lineH_27"}>{Lang({ id: "YiChengJiaoKeHuDaiBanTiXi", default:'已成交客户—待办提醒' })}</div>
            <div className={"mt_4 flex-item flexHeight"}>
                <PaymentCollectionDrawer className={"commonBox item"} btnName={Lang({ id: "DingJinCuiShou", default:'定金催收' })}
                                         refreshPage={()=>this.getTodo()}
                                         type={1} //1:定金 * 2:尾款 * 3:提货
                                         canOpen={todoModel.depositTaskNum>0}>
                    {this.renderItem(Lang({ id: "DingJinCuiShou", default:'定金催收' }),todoModel.depositTaskNum,true)}
                </PaymentCollectionDrawer>
                <PaymentCollectionDrawer className={"commonBox item"} btnName={Lang({ id: "WeiKuanCuiShou", default:'尾款催收' })}
                                         refreshPage={()=>this.getTodo()}
                                         type={2} // 1:定金 * 2:尾款 * 3:提货
                                         canOpen={todoModel.balanceTaskNum>0}>
                    {this.renderItem(Lang({ id: "WeiKuanCuiShou", default:'尾款催收' }),todoModel.balanceTaskNum,true)}
                </PaymentCollectionDrawer>
                <TakeDeliveryGoodsDrawer className={"commonBox item"} btnName={Lang({ id: "TiHuo", default:'提货' })}
                                         refreshPage={()=>this.getTodo()}
                                         type={3} // 1:定金 * 2:尾款 * 3:提货
                                         canOpen={todoModel.deliveryTaskNum>0}>
                    {this.renderItem(Lang({ id: "TiHuoTiXing", default:'提货提醒' }),todoModel.deliveryTaskNum,true)}
                </TakeDeliveryGoodsDrawer>
                <Link className="commonBox item" to={`/afterSale/customerInitiated`} target={"_blank"}>
                    {this.renderItem(Lang({ id: "DaiChuLiSuoPei", default:'待处理索赔' }),todoModel.claimTaskNum,true)}
                </Link>
                <SurveyTaskList type={1} className={"commonBox item"}
                                  refreshPage={()=>this.getTodo()}
                                  btnName={Lang({ id: "XinKeManYiDuDiaoCha", default:'新客 满意度调查 ' })}
                                  canOpen={todoModel.newBuyerSurveyTaskNum>0}>
                    {this.renderItem(Lang({ id: "XinKeManYiDuDiaoCha", default:'新客满意度调查' }),todoModel.newBuyerSurveyTaskNum,true)}
                </SurveyTaskList>
                <SurveyTaskList type={2} className={"commonBox item"}
                                  refreshPage={()=>this.getTodo()}
                                  btnName={Lang({ id: "YuLiuShiYongHuManYiDuDiao", default:'预流失用户满意度调查' })}
                                  canOpen={todoModel.preLossBuyerSurveyTaskNum>0}>
                    {this.renderItem(Lang({ id: "YuLiuShiYongHuManYiDuDiao", default:'预流失用户满意度调查' }),todoModel.preLossBuyerSurveyTaskNum,true)}
                </SurveyTaskList>
                {/*  后端无RAP 暂用 abnormalPoTotal*/}
                <div className={"commonBox item"}>
                    <Link className="link" to={
                        {
                            pathname: '/order/exceptionPendingOrder',
                            // search: `?${item.containerId}`,
                        }
                    }>
                        {this.renderItem(Lang({ id: "YiChangDaiChuLiDingDan", default:'异常待处理订单' }),todoModel.abnormalPoTotal,true)}
                    </Link>
                </div>
            </div>
        </Spin>);
    }
}